import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { AppLoaderComponent } from './components/loader/loader.component';
import { ContentComponent } from './core/iam/content.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonApp, IonRouterOutlet, AppLoaderComponent, ContentComponent],
  standalone: true,
})
export class AppComponent {
  constructor() {}
}
